import { createFileRoute } from '@tanstack/react-router';

import { TargetingBuilderEditorPage } from '../features/targeting/builder/components/TargetingBuilderEditorPage';

export const Route = createFileRoute('/targeting/$targetingId/edit')({
  component: EditTargetingPage,
});

function EditTargetingPage() {
  const { targetingId } = Route.useParams();
  return <TargetingBuilderEditorPage targetingId={targetingId} />;
}
